// @ts-nocheck

import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { colors } from 'app/shared/styles/_colors';

import AlertButton from 'app/shared/modules/AlertButton';
import Container from 'app/shared/core/Container';
import Divider from 'app/shared/modules/Divider';
import FilterPills from 'app/shared/modules/MobileSRP/ListingCards/FilterPills';

import { filterUtils_hasActiveFilters } from 'app/shared/utils/filterUtils';
import IconHouseOutlined from 'images/icons/house-outlined.svg';
import NearbyAreaListings from 'app/shared/modules/search-page/NearbyAreaListings';
import queryUtils from 'app/shared/utils/queryUtils';
import Row from 'app/shared/core/Row';
import './style.scss';
import Text from 'app/shared/core/Text';
import WidenSearchButton from 'app/shared/modules/search-page/WidenSearchButton';

const StyledDarkText = styled(Text)`
  color: ${colors['$hpx-grey-600']};
`;
const StyledImg = styled.img`
  color: ${colors['$hpx-grey-500']};
`;
class NoListingsFound extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const { area, query, filter, isSmallScreen } = this.props;
    const hasActiveFilters = filterUtils_hasActiveFilters(filter);
    const borderIsDrawn = query.border !== false;
    const iconSize = isSmallScreen ? 100 : 134;

    let noListingsTitle;

    if (hasActiveFilters) {
      noListingsTitle = 'No properties fit your criteria.';
    } else {
      if (borderIsDrawn) {
        noListingsTitle = 'No listings found';
      } else {
        noListingsTitle = `No properties available in ${area.name} at the moment.`;
      }
    }
    return (
      <div className="NoListingsFound">
        <Container>
          <StyledImg src={IconHouseOutlined} width={iconSize} height={iconSize} alt="" />
          <div className="NoListingsFound-title" size="sm">
            {noListingsTitle}
          </div>
          <FilterPills />
          {borderIsDrawn && (
            <Fragment>
              <Divider />
              <Row>
                <StyledDarkText size="sm">Expand your search by adding areas?</StyledDarkText>
              </Row>
              <WidenSearchButton area={area} />
            </Fragment>
          )}
          <Fragment>
            <NearbyAreaListings />
            <Divider />
            <div className="NoListingsFound-notify">
              <Row>
                <StyledDarkText size="sm">
                  Set up an alert to be notified as soon as a place is available in {area.name}.
                </StyledDarkText>
              </Row>
              <AlertButton />
            </div>
          </Fragment>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    area: state.area.area,
    filter: state.filter,
    query: queryUtils.parse(ownProps.location.search),
    isSmallScreen: state.app.device.screenWidth === 'sm',
  };
};

export default withRouter(connect(mapStateToProps)(NoListingsFound));
